import React, { useEffect } from "react";
import { BrowserRouter as Router, Link, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import About from "./Component/About";
import CartPage from "./Component/CartPage";
import { CartProvider } from "./Component/CartContext";
import CheckOut from "./Component/CheckOut";
import Contact from "./Component/Contact";
import Delivery from "./Component/Delivery";
import Footer from "./Component/Footer";
import Header from "./Component/Header";
import Main from "./Component/Main";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import Returns from "./Component/Returns";
import Shop from "./Component/Shop";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Faqs from "./Component/Faqs";
import Cookies from "./Component/Cookies";
import PaymentFailed from "./Component/PaymentFailed";
import PaymentStatus from "./Component/PaymentStatus";
import siteConfig from "./config/siteConfig";

const pageTitles = {
  "/": "Specialty Food, Cheese & Gourmet Gifts",
  "/shop": "Shop Artisan Food",
  "/about": "Our Story",
  "/contact": "Contact Us",
  "/cartpage": "Your Cart",
  "/checkout": "Checkout",
  "/paysuccess": "Order Confirmation",
  "/shipping": "Shipping & Delivery",
  "/returns": "Returns & Quality",
  "/privacy": "Privacy Policy",
  "/terms": "Terms of Service",
  "/faqs": "Frequently Asked Questions",
  "/cookies": "Cookie Policy",
  "/payment-failed": "Payment Incomplete",
  "/payment": "Payment Status",
};

function RouteEffects() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const baseTitle = pageTitles[location.pathname];
    const isProduct = location.pathname.startsWith("/products/") || location.pathname.startsWith("/shopDetails/");
    document.title = `${baseTitle || (isProduct ? "Product Details" : "Page Not Found")} | ${siteConfig.brandName}`;
  }, [location.pathname]);

  return null;
}

function NotFound() {
  return (
    <main className="not-found" id="main-content">
      <div className="not-found__inner">
        <span className="not-found__code">404</span>
        <h1>This shelf is empty.</h1>
        <p>The page may have moved, but there is plenty more worth tasting in the pantry.</p>
        <Link to="/shop">Return to the shop</Link>
      </div>
    </main>
  );
}

function App() {
  return (
    <CartProvider>
      <Router>
        <RouteEffects />
        <a className="skip-link" href="#main-content">Skip to main content</a>
        <div className="site-layout">
          <Header />
          <div className="site-layout__content">
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/shopDetails/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/cartpage" element={<CartPage />} />
              <Route path="/checkout" element={<CheckOut />} />
              <Route path="/order-confirmation" element={<PaySuccess />} />
              <Route path="/paysuccess" element={<PaySuccess />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shipping" element={<Delivery />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/faqs" element={<Faqs />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/payment-failed" element={<PaymentFailed />} />
              <Route path="/payment" element={<PaymentStatus />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
